import { render, staticRenderFns } from "./ContactFolders.vue?vue&type=template&id=54c5d16e&"
import script from "./ContactFolders.vue?vue&type=script&lang=js&"
export * from "./ContactFolders.vue?vue&type=script&lang=js&"
import style0 from "./ContactFolders.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports